import React from "react";
import { withRouter } from "react-router-dom";

const Privacy = props => {
  return (
    <div>
      {props.message && <p className="error">{props.message}</p>}
      <h3 className="heading">Data &amp; privacy</h3>
      <p className="subheading">
        We understand our responsibility to protect your personal data. Your
        privacy is important to us, and we've made it easy for you to stay in
        control.
      </p>
      <h4 className="formsubheading field">Review our privacy policy</h4>
      <p className="subheading opacity">
        <span>
          To read about how we collect, store and handle your personal data,
          read our
        </span>
        <a className="privacy" href="https://company.ausbiz.com.au/privacy-policy" target="_blank">
          &nbsp;privacy policy&nbsp;
        </a>
        .
      </p>

      <div className="downloadSection">
        <h4 className="formsubheading">Download your data</h4>
        <span className="subheading">Download your data</span>
        <button
          type="submit"
          className="btn  downloadBtn"
          onClick={props.downloadHandler}
        >
          Download
        </button>
      </div>

      <div className="deleteSection">
        <h4 className="formsubheading">Delete your account</h4>
        <p className="subheading d-flex align-items-center">
          <img src="/assets/svg/privacyPoints.svg" className="warningIcon" />
          <span>
            Your preference will be lost, including companies and topics you
            follow
          </span>
        </p>
        <p className="subheading d-flex align-items-center">
          <img src="/assets/svg/privacyPoints.svg" className="warningIcon" />
          <span>This will delete your account on all devices</span>
        </p>
        <p className="subheading d-flex align-items-center">
          <img src="/assets/svg/privacyPoints.svg" className="warningIcon" />
          <span>This is irreversible and cannot be undone</span>
        </p>
      </div>

      <button
        type="button"
        id="abc"
        className="btn deleteBtn"
        data-toggle="modal"
        data-target="#deleteModal"
        onClick={() => props.openModalPopup()}
        style={{
            marginTop: "14px"
        }}
      >
        Delete account
      </button>
    </div>
  );
};

export default withRouter(Privacy);
